import { Entity } from '@app/core';
import { IMarket, IMarketEntity } from '@games/interfaces';
import { MarketEntity } from '@games/entities/market-entity.entity';

export class Market extends Entity<IMarket> {
  constructor(props: IMarket) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get entities(): MarketEntity[] {
    return (
      this.props.entities &&
      this.props.entities.map((entity: IMarketEntity) => new MarketEntity(entity))
    );
  }
}
